import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/Privacy';
import HomePage from './components/HomePage';
import Timer from './components/Timer';

function App() {
  return (
    <BrowserRouter>
      <div>
        
        <Routes>
          <Route path="/" element={<HomePage/>} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/timer" element={<Timer />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;